import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import MainContent from "./MainContent";
import { adminApiRequest } from "../utils/adminApi";

const Layout = ({ username, onLogout }) => {
  const [activeTab, setActiveTab] = useState(() => {
    return sessionStorage.getItem("admin_activeTab") || "orders";
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [restaurantOpen, setRestaurantOpen] = useState(true);
  const [loadingRestaurantStatus, setLoadingRestaurantStatus] = useState(true);
  const [togglingRestaurantStatus, setTogglingRestaurantStatus] =
    useState(false);

  useEffect(() => {
    sessionStorage.setItem("admin_activeTab", activeTab);
  }, [activeTab]);

  useEffect(() => {
    const fetchRestaurantStatus = async () => {
      try {
        const res = await adminApiRequest({
          script: "get-restaurant-status",
        });

        if (res?.success) {
          setRestaurantOpen(Boolean(Number(res.is_open)));
        }
      } catch (error) {
        console.error("Failed to fetch restaurant status:", error);
      } finally {
        setLoadingRestaurantStatus(false);
      }
    };

    fetchRestaurantStatus();
  }, []);

  const handleRestaurantToggle = async () => {
    if (togglingRestaurantStatus) return;

    setTogglingRestaurantStatus(true);

    try {
      const nextStatus = !restaurantOpen;

      const res = await adminApiRequest({
        script: "toggle-restaurant-status",
        data: {
          is_open: nextStatus ? 1 : 0,
        },
      });

      if (!res?.success) {
        throw new Error(res?.message || "Failed to update restaurant status");
      }

      setRestaurantOpen(Boolean(Number(res.is_open)));
    } finally {
      setTogglingRestaurantStatus(false);
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (isSidebarOpen) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100">
      <div className="flex min-h-screen">
        <Sidebar
          username={username}
          activeTab={activeTab}
          handleTabClick={handleTabClick}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          onLogout={onLogout}
          restaurantOpen={restaurantOpen}
          onRestaurantToggle={handleRestaurantToggle}
          loadingRestaurantStatus={loadingRestaurantStatus}
        />

        <MainContent
          activeTab={activeTab}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      </div>
    </div>
  );
};

export default Layout;
